import React from "react";

export default function BucketsTableMaxBattery(props) {
  let { data } = props;
  return (
    <>
      {(data.length == 0) ? "<tr><td colSpan={2}>No data found</td></tr>" : data.map((x, index) => {
        return (<tr key={x.key}>
          <td scope="row ">{x.key.vehicleId}</td>
          <td >{(x.BMS_Max_Cell_Temp.value).toFixed(2)} </td>
        </tr>)
      })}
    </>
  );
}